
if (window.location.hostname==='localhost'){
	this.endpoint = 'http://localhost:3001';
} else if (window.location.hostname==='test.skibro.com'){
	this.endpoint = 'https://test.skibro.com:3001';
} else {
	console.log('Production');
	this.endpoint = 'https://api.skibro.com';
}

const services = {
	'api': {
		live: this.endpoint,
		test: this.endpoint,
		dev: this.endpoint,
	},
	'bookByLesson': {
		live: '//www.skibro.com/en/bookByLesson',
		test: '//testsite.skibro.com/en/bookByLesson',
		dev: '//testsite.skibro.com/en/bookByLesson'
	},
	'get-widget-data': {
		live: `${this.endpoint}/api/mobile/get-resorts`,
		test: `${this.endpoint}/api/mobile/get-resorts`,
		dev: `${this.endpoint}/api/mobile/get-resorts`
	},
	'pagehit':{
		live: `${this.endpoint}/api/partner/pagehit`,
		test: `${this.endpoint}/api/partner/pagehit`,
		dev: `${this.endpoint}/api/partner/pagehit`,
	},
	'setup-widget': {
		live: `${this.endpoint}/api/setup-widget`,
		test: `${this.endpoint}/api/setup-widget`,
		dev: `${this.endpoint}/api/setup-widget`
	},
	'website-v2' : {
		live: '//www.skibro.com/en/search',
		test: '//staging.skibro.net/en/search',
		dev: '//localhost:3000/en/search'
	}
};

// such a terrible name!  Should be URLService
class HTTPService {
	isLive(){
		if (window.location.href.includes('localhost')){
			return false;
		}
		if (window.location.href.includes('test')){
			return false;
		}
		return true;
	}
	isTest(){
		return window.location.href.includes('test');
	}
	isDev(){
		return window.location.href.includes('localhost');
	}
	currentSystem(){
		if (this.isLive()) return 'live';
		if (this.isDev()) return 'dev';
		if (this.isTest()) return 'test';
	}
	getURLForService(serviceName){
		let url = services[serviceName][this.currentSystem()];
		return url;
	}
}

const httpService = new HTTPService();

export default httpService;


// WEBPACK FOOTER //
// ./src/services/HTTP.service.js